import { userRoles } from '@constants/common';
import { lazy } from 'solid-js';

const JiraTicketMetrics = lazy(() => import('./JiraTicketMetrics'));

export const JiraTicketMetricsRoute = {
  path: '/jira-ticket-metrics',
  component: () => <JiraTicketMetrics />,
  protected: true,
  roles: [userRoles.ADMIN, userRoles.SUPER_ADMIN],
};
